export const CheckEipQuota = 'step2/CheckEipQuota';
export const DescribeKeadMinRate = 'step2/DescribeKeadMinRate';
export const DescribeKead = 'step2/DescribeKead';
//高防 白名单效验
export const ValidWhitelist = 'step2/ValidWhitelist';